import AppRouter from './routes/AppRouter';
import SocketProvider from '@/components/common/SocketProvider';

export default function App() {
  return (
    <SocketProvider>
      <AppRouter />
    </SocketProvider>
  );
}
